import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=3ba952b2&scoped=true"
import script from "../js/access.js?vue&type=script&lang=js&external"
export * from "../js/access.js?vue&type=script&lang=js&external"
import style0 from "./Access.vue?vue&type=style&index=0&id=3ba952b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba952b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba952b2')) {
      api.createRecord('3ba952b2', component.options)
    } else {
      api.reload('3ba952b2', component.options)
    }
    module.hot.accept("./Access.vue?vue&type=template&id=3ba952b2&scoped=true", function () {
      api.rerender('3ba952b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/teacher/pages/Access.vue"
export default component.exports